import { type RankedOpen, useBestOpens } from "../../shared/bestOpens.js";

export interface TopHitsContent {
  title: string;
  /** Most valuable first. `[]` renders nothing, and is all a signed-out visitor gets. */
  opens: RankedOpen[];
}

/** The boxes page's "Top hits": the shopper's best recent opens, as the home page shows them. */
export function useTopHitsContent(): TopHitsContent {
  return { title: "Top hits", opens: useBestOpens() };
}
